module.exports = __webpack_public_path__ + "oxford.5602c32.png";